import { useState } from 'react';
import { Card, Tabs } from 'antd';
import HeadingTypography from 'src/app/components/shared/Typography/Heading';
import { LeadCreditStatusEnum } from '@rasayi-workspace/shared';
import { useLeadContext } from '@contexts';
import { Procurements } from '../procurements';
import { Review } from '../Review';

const SectionLayoutReview = () => {
  const [activeTab, setActiveTab] = useState('1');
  const { creditFiltars, setCreditFiltars, repeatedCreditFilters, setRepeatedCreditFilters, rejectedLeadFilters, setRejectedLeadFilters, approvedLeadFilters, setApprovedLeadFilters } =
    useLeadContext();

  return (
    <div className="pt-4 bg-gray-100 rounded-lg">
      <Card>
        <div className="border-2 border-black rounded-lg">
          <Tabs defaultActiveKey="1" onChange={key => setActiveTab(key)} tabBarStyle={{ borderBottom: '1px solid #d9d9d9' }} className="text-lg font-semibold tabs-custom-style">
            <Tabs.TabPane
              key="1"
              tab={
                <>
                  <HeadingTypography fontSize={16} classNames={`flex items-center h-[40px] px-[32px] ${activeTab !== '1' ? 'text-gray-400 text-[#DBD7D7]' : ''}`}>
                    Pending
                  </HeadingTypography>{' '}
                  {activeTab === '1' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                </>
              }
            >
              <Review
                approvalStatus={LeadCreditStatusEnum.PENDING}
                showRepeated={false}
                activeTab={activeTab}
                tabKey={'1'}
                actions={true}
                savedFilters={creditFiltars}
                setSavedFilters={setCreditFiltars}
              />
            </Tabs.TabPane>

            <Tabs.TabPane
              key="2"
              tab={
                <>
                  <HeadingTypography fontSize={16} classNames={`flex items-center h-[40px] px-[32px] ${activeTab !== '2' ? 'text-gray-400 text-[#DBD7D7]' : ''}`}>
                    Approved
                  </HeadingTypography>{' '}
                  {activeTab === '2' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                </>
              }
            >
              <>TBD</>
            </Tabs.TabPane>

            <Tabs.TabPane
              key="3"
              tab={
                <>
                  <HeadingTypography fontSize={16} classNames={`flex items-center h-[40px] px-[32px] ${activeTab !== '3' ? 'text-gray-400 text-[#DBD7D7]' : ''}`}>
                    Rejected
                  </HeadingTypography>{' '}
                  {activeTab === '3' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#FCD4D6]" />}
                </>
              }
            >
              <>TBD</>
            </Tabs.TabPane>

          </Tabs>
        </div>
      </Card>
    </div>
  );
};

export default SectionLayoutReview;
